export const arrayAverage = (arr: number[]) => arr.reduce((a, b) => a + b, 0) / (arr.length || 1);
